module.exports = __webpack_public_path__ + "img/kastina-shield.1b55f006.png";